/* Plein5 — winkelwagen opent na toevoegen + directe afrekenknop (23-10-2026)
   1) Onze eigen knoppen (productpagina, bankkiezer, sticky balk) sturen alleen
      cart:updated/cart:build. Het thema opent de lade alleen op ajaxProduct:added
      of cart:open. Daardoor zag de klant niets gebeuren en drukte hij nog een keer
      (31x een wandpaneel). Hier vangen we elke geslaagde POST naar /cart/add.js af:
      lade open + twee seconden "TOEGEVOEGD ✓" op de knop.
   2) "Veilig afrekenen" ging via het thema (form submit met wachtlogica) en
      belandde soms op /cart of bleef draaien. Nu: klik = direct naar /checkout. */
(function () {
  'use strict';
  if (window.P5CartOpen || typeof window.fetch !== 'function') return;
  window.P5CartOpen = true;

  var origFetch = window.fetch;

  function isAdd(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return /(^|\/)cart\/add(\.js)?(\?|$)/.test(url);
  }

  // Oorspronkelijke knoptekst onthouden vóór de knop op "BEZIG..." springt
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#p5p-atc') : null;
    if (b && !b.dataset.p5Orig) b.dataset.p5Orig = b.textContent.trim();
  }, true);

  function naToevoegen() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    var b = document.getElementById('p5p-atc');
    // De bankkiezer (sectie met data-p5-bank) zet zijn eigen "TOEGEVOEGD"-tekst
    if (!b || document.querySelector('.p5p[data-p5-bank]')) return;
    var orig = b.dataset.p5Orig || b.textContent.trim();
    if (orig === 'BEZIG...') orig = 'IN WINKELWAGEN';
    window.setTimeout(function () { b.textContent = 'TOEGEVOEGD ✓'; }, 120);
    window.setTimeout(function () {
      if (b.textContent.trim() === 'TOEGEVOEGD ✓') b.textContent = orig;
    }, 2400);
  }

  window.fetch = function (input, init) {
    var p = origFetch.apply(this, arguments);
    try {
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (String(method).toUpperCase() === 'POST' && isAdd(input)) {
        p.then(function (res) { if (res && res.ok) naToevoegen(); }).catch(function () {});
      }
    } catch (err) {}
    return p;
  };

  // Afrekenen: niet via het formulier van het thema, maar rechtstreeks.
  // Voorwaarden-vinkje (als dat ooit aan staat) respecteren we wel.
  document.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('#CartDrawer .p5c-checkout, #CartDrawer .cart__checkout') : null;
    if (!knop) return;
    var terms = document.getElementById('CartTermsDrawer');
    if (terms && !terms.checked) return; // thema toont dan zijn eigen melding
    e.preventDefault();
    e.stopImmediatePropagation();
    knop.classList.add('btn--loading');
    knop.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    window.location.href = root.replace(/\/$/, '') + '/checkout';
  }, true);
})();
